import React, { useSyncExternalStore } from 'react';
import { READING_WORDING } from '../domain/reading';
import { awaitingServerCount, onAwaitingServerChange } from '../data/serverAnswers';
import ReadFailed from './ReadFailed';
import e from './EmptyState.module.css';

// What a screen shows where an empty state, a zero or a "none" would be while
// the list behind it is unread (#629, #637): nothing a sighted teacher reads as
// an answer, and "Loading…" to a screen reader. Quiet: a warm start answers
// from the device's store in a frame or two, where a spinner would be noise;
// a cold one answers in seconds, with the page around it drawn. The phones'
// spinner is the same state.
//
// `as` lets it stand where only a given element may: a table cell's text, or
// an inline run. `failed` (#647): the read stopped before it answered, and the
// failed state stands here instead — inline for an inline `as`.
//
// Waiting for the server (#651): while some list's only answer is a cache that
// has never had the server's answer — a device that never synced, most likely
// offline — the block form says so in the core's words, rather than the quiet
// placeholder standing for good with nothing to say why. The registry is
// device-wide (`src/data/serverAnswers.js` says why). The inline form stays
// quiet; the block on the same screen carries the sentences.
export default function Unread({ as: Tag = 'div', failed = false }) {
  const awaiting = useSyncExternalStore(onAwaitingServerChange, awaitingServerCount) > 0;
  if (failed) return <ReadFailed inline={Tag !== 'div'} />;
  if (awaiting && Tag === 'div') {
    return (
      <div className={e.empty} role="status">
        <div className={e.title}>{READING_WORDING.awaitingTitle}</div>
        <div className={e.desc}>{READING_WORDING.awaitingDescription}</div>
      </div>
    );
  }
  return <Tag className="sr-only" role="status">{READING_WORDING.loading}</Tag>;
}
